import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { MetaSingleImageUrlInitModel, MetaSingleImageUrlInitVariables, MetaSingleImageUrlModel, MetaSingleImageUrlVariables } from '../../../../../models/meta-template/meta-single-image-url.interface';

@Component({
    selector: 'app-meta-single-image-url',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './meta-single-image-url.component.html',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class MetaSingleImageUrlComponent extends BaseComponent implements OnInit {
  //@ input
  @Input() block: MetaSingleImageUrlModel = new MetaSingleImageUrlInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new MetaSingleImageUrlInitVariables()
    }
  }

  //@ placeholders
  linkPlaceholder: string = 'Enter landing page URL';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof MetaSingleImageUrlVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
